var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.65 2C11.7387 2 11 2.70103 11 3.56579V11.477C11 11.9704 11.6547 12.1883 11.9795 11.8031L13.2 10.4079H20.35C21.2613 10.4079 22 9.70687 22 8.84211V3.5658C22 2.70103 21.2613 2 20.35 2H12.65Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.75V7.25H8C6.48122 7.25 5.25 8.48122 5.25 10V12H4C3.44772 12 3 12.4477 3 13V14C2.44772 14 2 14.4477 2 15V19C2 19.5523 2.44772 20 3 20V21C3 21.5523 3.44772 22 4 22H8.92963C9.59834 22 10.2228 21.6658 10.5937 21.1094L11.1679 20.2481C11.5638 19.6543 12.4362 19.6543 12.8321 20.2481L13.4063 21.1094C13.7772 21.6658 14.4017 22 15.0704 22H20C20.5523 22 21 21.5523 21 21V20C21.5523 20 22 19.5523 22 19V15C22 14.4477 21.5523 14 21 14V13C21 12.4477 20.5523 12 20 12H19.75V11.9079H18.25V12H13.8002L13.1149 12.7833C12.5023 13.4983 11.5923 13.6251 10.8942 13.3928C10.3185 13.2011 9.75552 12.7152 9.5666 12H6.75V10C6.75 9.30964 7.30964 8.75 8 8.75H9.5ZM17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19ZM9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrChat);
export default __webpack_public_path__ + "static/media/vr-chat.5f31a7f3193a362a3883b0a7c01a8fbe.svg";
export { ForwardRef as ReactComponent };